import {
  getGraphsWithAnalysis,
  getGraphValue,
} from 'affiny-core/helpers/personalityReport';
import { IPersonalityReportGraph } from 'affiny-core/modules/personalityReport/types';
import { Box, Flex, Grid, rem, ValueBar } from 'affiny-ui/src';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonalityReportLayerBottomChapterNavigation } from './PersonalityReportLayerBottomChapterNavigation';
import { PersonalityReportLayerParagraph } from './PersonalityReportLayerParagraph';
import { PersonalityReportLayerValuesSubChapter } from './PersonalityReportLayerValuesSubChapter';
import { PersonalityReportLayerTitle } from './PersonalityReportLayerTitle';
import { PersonalityReportLayerValuesSubMenu } from './PersonalityReportLayerValuesSubMenu';

interface IPersonalityReportLayerValuesChapter {
  graphs: IPersonalityReportGraph[];
  setSection: (arg: string) => void;
}

export const PersonalityReportLayerValuesChapter = ({
  graphs,
  setSection,
}: IPersonalityReportLayerValuesChapter) => {
  const { t } = useTranslation();
  const graphsWithAnalysis = getGraphsWithAnalysis(graphs);
  const [activeTitle, setActiveTitle] = useState(
    graphsWithAnalysis.length ? graphsWithAnalysis[0].id : ''
  );

  return (
    <Box>
      <Grid height="100%">
        <Flex gridColumn="span 4" flexDirection="column">
          <Box position="sticky" top={rem(161)}>
            <PersonalityReportLayerValuesSubMenu
              graphs={graphsWithAnalysis}
              nbOfItem={graphsWithAnalysis.length - 1}
              activeTitle={activeTitle}
            />
          </Box>
        </Flex>
        <Flex gridColumn="span 8" flexDirection="column">
          <PersonalityReportLayerTitle size="xxLarge" isPrimary>
            {t(`personalityReport.values.intro.title`)}
          </PersonalityReportLayerTitle>

          <PersonalityReportLayerParagraph>
            {t(`personalityReport.values.intro.paragraph1`)}
          </PersonalityReportLayerParagraph>
          <PersonalityReportLayerParagraph>
            {t(`personalityReport.values.intro.paragraph2`)}
          </PersonalityReportLayerParagraph>
          <PersonalityReportLayerParagraph>
            {t(`personalityReport.values.intro.paragraph3`)}
          </PersonalityReportLayerParagraph>

          <Flex flexWrap="wrap" justifyContent="space-between" py="small">
            {graphsWithAnalysis.map((graph, idx) => (
              <ValueBar
                key={idx}
                title={t(`personalityReport.values.valueLabels.${graph.id}`)}
                value={getGraphValue(graph)}
                containerStyle={{ mb: 'large', width: '45%' }}
              />
            ))}
          </Flex>

          <PersonalityReportLayerParagraph>
            {t(`personalityReport.values.intro.conclusion`)}
          </PersonalityReportLayerParagraph>

          {graphsWithAnalysis.map(graph => (
            <PersonalityReportLayerValuesSubChapter
              key={graph.id}
              graph={graph}
              setTitle={setActiveTitle}
            />
          ))}
          <PersonalityReportLayerBottomChapterNavigation
            chapter="values"
            setSection={setSection}
          />
        </Flex>
      </Grid>
    </Box>
  );
};
